export const formatNumber = (
    num: number | string | null | undefined,
    /** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat */
    options?: Intl.NumberFormatOptions,
    locale?: string,
): string => {
    if (num == null) {
        return ''
    }

    const realNumber = +num

    if (Number.isNaN(realNumber)) {
        return ''
    }

    return realNumber.toLocaleString(locale, {
        currency: 'USD',
        ...options,
    })
}
